const COUNT_COLUMN = { type: 'number', flex: 1 };

// The count columns shared by the course list and a course's per-user page.
export const COUNT_COLUMNS = [
  { ...COUNT_COLUMN, field: 'flashcardDecks', headerName: 'Flashcard Decks' },
  { ...COUNT_COLUMN, field: 'quizzes', headerName: 'Practice Quizzes' },
  { ...COUNT_COLUMN, field: 'summaries', headerName: 'Summary Notes' },
  { ...COUNT_COLUMN, field: 'total', headerName: 'Total' },
];
